import { FC } from 'react'
import IconImage from '@/assets/img/icons/sortingUp.png'
import { TypeIcon } from '@/components/Atoms/Icons/types'

const Icon: FC<TypeIcon> = ({ width = 30, height = 30 }) => {
  return (
    <img
      src={IconImage}
      alt='sortingUp'
      width={width}
      height={height}
    />
  )
}

export default Icon
